<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-08-19 10:39:11
-->
<template>
  <div class="background-contain">
    <div class="header-block"></div>
    <div class="home-page">
      <!-- 头部 -->
      <div class="header">
        <img src="@/assets/cryptopag-logo.png" alt="" />
        <div class="header-btn-contain">
          <!-- <div class="header-btn1" @click="toUrl(1)">登录</div> -->
          <!-- <div class="header-btn2" @click="toUrl(2)">注册</div> -->
          <el-dropdown placement="bottom" @command="changeLanguage">
            <span class="el-dropdown-link">
              {{language}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="pt-BR">🇧🇷 Português</el-dropdown-item>
              <el-dropdown-item command="en-US">🇺🇸 English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-popover placement="bottom" title="" trigger="hover" content="">
            <div slot="reference" class="el-dropdown-link">
              <div>{{ $t("components.header.277034-0") }}</div>
            </div>
            <div>business@beexpay.com</div>
          </el-popover> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerPart",
  props: {
    msg: String,
  },
  data() {
    return {
      language: "Português",
    };
  },
  mounted() {
    const savedLanguage = localStorage.getItem("cryptopagLanguage") || "pt-BR";
    this.language = savedLanguage === "pt-BR" ? "🇧🇷 PT" : "🇺🇸 EN";
    this.$i18n.locale = savedLanguage;
  },
  methods: {
    changeLanguage(locale) {
      localStorage.setItem("cryptopagLanguage", locale);
      this.$i18n.locale = locale;
      this.language = locale === "pt-BR" ? "🇧🇷 PT" : "🇺🇸 EN";
    },
    toUrl(type) {
      if (type == 1) {
        location.href = "https://platform.hkyoucard.com/ ";
      } else {
        location.href = "https://platform.hkyoucard.com/#/register";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./headerCss/max.css" scoped></style>
<style src="./headerCss/middle.css" scoped></style>
<style src="./headerCss/flat.css" scoped></style>
<style src="./headerCss/min.css" scoped></style>
<style scoped></style>
